export default __webpack_public_path__ + "static/media/500_Confident.12d7a12d.svg";